const baseUri = ':baseUri/surveys';
export const npsSurveyUri = `${baseUri}/nps`;
export const npsScoreUri = `${baseUri}/nps-score`;
export const npsSuggestionsUri = `${baseUri}/nps-suggestions`;
export const interviewUri = `${baseUri}/interview/:interviewee`;
export const requestSurveyByEmail = `${baseUri}/by-email`;
